'use strict';

var __chunk_4 = require('./chunk-e6d921c6.js');

function get(ks, o) {
  ks = __chunk_4.isArray(ks) ? ks : ks.toString().split('.');
  return ks.reduce(function (a, k) {
    return a !== undefined ? a[k] : undefined;
  }, o);
}

module.exports = get;
